import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import { SPECIES_LIST_PATH } from "~/modules/settings/constants";

import SpeciesForm, { SpeciesFormInputs } from "../../components/SpeciesForm";
import useSettingsSpeciesCreateRoute_Create from "./api/useSettingsSpeciesCreateRoute_Create";

export default function SettingsSpeciesCreateRoute() {
    const { t } = useTranslation("species");

    const navigate = useNavigate();

    const { createSpecies, error } = useSettingsSpeciesCreateRoute_Create();

    const handleSubmit = async (data: SpeciesFormInputs) => {
        const result = await createSpecies(data);
        if (result.data?.settingsSpeciesCreate) {
            navigate(generatePath(SPECIES_LIST_PATH));
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("settingsSpeciesCreateRoute.title")}>
                <SpeciesForm onSubmit={handleSubmit} error={error} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
